<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">武侠管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>邀请排名</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-select
          v-model="filter.leagueId"
          @change="getRecordList"
          placeholder="门派"
        >
          <el-option
            v-for="item in list"
            :key="item.id"
            :label="item.name && item.name.zh"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>

      <el-table :data="rankingList">
        <el-table-column prop="leagueId" label="门派ID"></el-table-column>
        <el-table-column prop="userId" label="用户ID"></el-table-column>
        <el-table-column prop="userName" label="用户名"></el-table-column>
        <el-table-column prop="total" label="邀请人数"></el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="totalCount"
        @pageChanged="handleCurrentChange"
      ></pagination>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import Pagination from 'components/pagination';
import math from 'common/math';
export default {
  name: 'leagueRanking',
  data() {
    return {
      filter: {
        leagueId: undefined
      },
      math
    };
  },
  computed: {
    ...mapState('leagueInviterRanking', [
      'rankingList',
      'pagination',
      'totalCount'
    ]),
    ...mapState('league', ['list'])
  },
  watch: {
    list: {
      handler(val) {
        if (val && val.length) {
          this.filter.leagueId = val[0].id;
          this.getRecordList();
        }
      },
      immediate: true
    }
  },
  components: {
    Pagination
  },
  methods: {
    ...mapActions('leagueInviterRanking', ['getRankingList', 'removeLabel']),
    ...mapActions('league', ['getList']),
    getRecordList(data = {}) {
      this.getRankingList({ ...this.filter, ...this.pagination, ...data });
    },
    handleCurrentChange(pagination) {
      this.getRecordList(pagination);
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.change {
  ::v-deep .el-button {
    margin-left: 20px;
  }
}
</style>
